import PropTypes from "prop-types";

import ChallengeDetailCard from "./ChallengeDetailCard";
import { challengesListCss } from "./ChallengesListSectionContainer.style";

const topicType = {
  topic_id: PropTypes.string,
  title: PropTypes.string,
  image: {
    url: PropTypes.string,
    alt: PropTypes.string,
  },
  description: PropTypes.string,
  total_articles: PropTypes.number,
  total_activities: PropTypes.number,
  done_activities: PropTypes.number,
  total_standards: PropTypes.number,
  tokens: PropTypes.number,
  earned_tokens: PropTypes.number,
};

const propTypes = {
  isHomeVersion: PropTypes.bool,
  topics: PropTypes.arrayOf(PropTypes.shape(topicType)),
};

const ChallengesListSectionContainer = ({ isHomeVersion = false, topics }) => {
  return (
    <div css={challengesListCss}>
      {topics?.map((topic) => (
        <ChallengeDetailCard
          key={Math.random()}
          isHomeVersion={isHomeVersion}
          topic={topic}
        />
      ))}
    </div>
  );
};

ChallengesListSectionContainer.propTypes = propTypes;

export default ChallengesListSectionContainer;
